import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAuthStore = defineStore(
  'auth',
  () => {
    let token = ref('');

    function updateToken(newToken) {
      token.value = newToken;
    }

    function reset() {
      updateToken('');
    }

    return {
      token,
      updateToken,
      reset,
    };
  },
  {
    persist: true,
  },
);
